import React, { useEffect, useState, useContext } from 'react';
import { useStore } from "../../../stores/store";
import { 
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, 
  PieChart, Pie, Cell, LineChart, Line, Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, AreaChart, Area 
} from 'recharts';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import AuthContext from "../../../context/AuthProvider";
import { useSetMenu } from "../../../hooks/useSetMenu";
function Dashboard() {
  const { mainStore } = useStore();
  useSetMenu(mainStore.FacilityDashboardMenuType, mainStore.FacilityDashboardMenuNo);
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useContext(AuthContext);
  useEffect(() => {
    // Dashboard data fetching is disabled
  }, []);

  return (
    <div>
      <h4>Facility Dashboard</h4>
      <p>Dashboard charts are currently disabled. Enable data fetching to view visualizations.</p>
    </div> 
  );
}

export default Dashboard;
